export default {"src":"/_next/static/media/renewcheck-icon.61a253a9.svg","height":40,"width":40};